import styled from 'styled-components'
import DatePicker from 'react-date-picker';

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const ScrollWrapper = styled.div`
  overflow-y: scroll;
`

export const ModalHead = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const ModalFooter = styled.div`
  margin-top: auto;
  padding: 24px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const LevelRowContainer = styled.div.attrs({
  className: `row col-12 mx-0`
})`
  border-top: ${({ borderNone, theme }) => borderNone ? 'none' : `1px solid ${theme.mocaLtGrey}`};
  padding: ${({ padding }) => padding ? padding : '24px 12px'};
`
export const InputRow = styled.div`
  flex: 7;
  display: flex;
  flex-direction: column;
`

export const StyledDatePicker = styled(DatePicker)`
  .react-date-picker__wrapper {
    border-radius: 6px !important;
    font-size: 14px !important;
    height: 34px !important;
    border: 1px solid ${({ theme }) => theme.mocaGrey};
  }

  .react-date-picker__inputGroup {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .react-date-picker__clear-button{
    display: none;
  }

  width: 100%;
`

export const Accordion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${({ rad }) => (rad ? rad : '4px')};
  width: ${({ width, auto }) => (auto ? 'auto' : width ? width : '100%')};
  height: ${({ height }) => (height ? height : '100%')};
  background-color: ${({ bg, theme }) => (bg ? bg : theme.white)};
  color: ${({ color, theme, transparent, bg }) => (transparent ? bg ? bg : theme.mocaGreen : color ? color : theme.white)};
  border: ${({ bordered, bg, theme }) => (bordered ? `1px solid ${bg ? bg : theme.black}` : 'none')};
  padding: ${({ padding }) => padding ? padding : 'inherit'};
  margin-top: ${({ mt }) => mt ? mt : '0'};
  margin-bottom: ${({ mb }) => mb ? mb : '0'};
  font-weight: ${({ weight }) => (weight ? weight : 'bold')};
  font-size: ${({ size }) => (size ? size : '14px')};
  cursor: pointer;
`

export const CardContainer = styled.div`
  padding: ${({ padding }) => padding ? padding : '10px'};
  margin-top: ${({ mt }) => mt ? mt : '0'};
  margin-bottom: ${({ mb }) => mb ? mb : '0'};
  background: #FFFFFF;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
`

export const BorderContainer = styled.div`
  padding: ${({ padding }) => padding ? padding : '0'};
  margin-top: ${({ mt }) => mt ? mt : '0'};
  margin-bottom: ${({ mb }) => mb ? mb : '0'};
  margin-right: ${({ mr }) => mr ? mr : '0'};
  border: 1px solid ${({ borderColor, theme }) => borderColor ? borderColor : theme.mocaLtGrey};
  border-radius: 4px;
  width: ${({ width }) => width ? width : '100%'};
  height: ${({ height }) => height ? height : '100%'};
  display: flex;
  flex-direction: column;
  justify-content: ${({ justify }) => (justify ? justify : 'center')};
  align-items: center;
  cursor: ${({ showPointer }) => (showPointer ? 'pointer' : 'default')};
`